import React from 'react';
import { getAllParams } from '../service/utils';

const AccessibilityHidden = ({ children, ...params }) => {
  const accessibilityParams = getAllParams(params);

  return React.Children.map(children, (child) => {
    if (typeof child === 'string') {
      // Wrap string children with a span and add aria-hidden
      return <span {...accessibilityParams} aria-hidden="true">{child}</span>;
    } else if (React.isValidElement(child)) {
      // Add aria-hidden to valid React elements
      return React.cloneElement(child, {
        ...accessibilityParams,
        'aria-hidden': true,
      });
    }
    return child;
  });
};

export default AccessibilityHidden;
